/** Full-page browser redirect used by session sign-in/out flows. */
export function redirectBrowserTo(url: string): void {
  window.location.assign(url);
}
